var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditReedem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 507.374,
    height: 374.856,
    viewBox: "0 0 507.374 374.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(-2486.895 -3181.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 480.072,
    height: 50.252,
    transform: "translate(2492.179 3338.795)",
    fill: "#f47257"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(2497.996 3255.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M2856.24,3594.322a927.067,927.067,0,0,0-346.563-103.842q6.709-78.572,13.418-157.145A1071.9,1071.9,0,0,1,2923.8,3453.4Z",
    transform: "translate(-2509.677 -3333.335)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M2531.516,3474.151q4.573-49,9.145-98.006c12.686,1.3,24.052-6.885,25.433-18.621a1064.057,1064.057,0,0,1,335.968,100.668c-4.723,10.733.818,23.986,12.248,29.911l-41.475,88.318a19.944,19.944,0,0,0-27.686,9.782,934.407,934.407,0,0,0-295.03-88.4A21.141,21.141,0,0,0,2531.516,3474.151Z",
    transform: "translate(-2520.875 -3345.738)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(53.111 61.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M2929.966,3531.445c-9.757,28.1-39.85,42.415-67.761,33.837-27.893-8.646-45.818-37.783-39.545-66.96,6.254-29.126,37.217-46.579,68.6-36.872C2922.661,3471.123,2939.712,3503.4,2929.966,3531.445Z",
    transform: "translate(-2722.625 -3458.752)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M2892.141,3572.138q1.171-4.7,2.339-9.41a50.934,50.934,0,0,1-11.377-5.327,6.073,6.073,0,0,1-2.19-7.884l.173-.331a5.834,5.834,0,0,1,8.417-2.054,37.452,37.452,0,0,0,10.429,4.828c5.7,1.6,10.159.566,11.191-3.385.975-3.747-1.622-7.077-8.52-11.652-9.973-6.587-16.338-13.46-14.141-23.126,1.986-8.754,10.066-13.992,21.836-12.963q1.156-4.709,2.309-9.419,5.192,1.439,10.372,2.931-1.11,4.351-2.22,8.7a47.872,47.872,0,0,1,9.212,4.1,6.043,6.043,0,0,1,2.4,8.2h0a6.128,6.128,0,0,1-8.562,1.814,34.208,34.208,0,0,0-8.792-3.874c-6.757-1.919-9.623.276-10.3,3.048-.8,3.279,2.323,6.328,10.221,12,11.116,7.693,14.443,14.655,12,23.488-2.435,8.756-10.731,14.252-22.589,12.949q-1.3,5.039-2.606,10.077Q2896.951,3573.469,2892.141,3572.138Z",
    transform: "translate(-2752.795 -3475.5)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M2702.181,3505.473q-41.389-9.551-83.505-15.54.973-7.555,1.947-15.11,42.671,6.062,84.675,15.759Z",
    transform: "translate(-2618.676 -3466.992)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M3149.2,3643.4q-38.516-18.837-78.311-34.275,2.517-7.151,5.032-14.3,40.317,15.646,79.407,34.755Q3152.264,3636.487,3149.2,3643.4Z",
    transform: "translate(-2850.543 -3528.52)",
    fill: "#50bfa5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(2504.315 3181.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2913.475,3336.866c-111.695,23.335-218.055,70.1-313.479,137.829l-77.349-133.467c110.331-78.312,233.308-132.381,362.452-159.362Q2899.286,3259.366,2913.475,3336.866Z",
    transform: "translate(-2522.647 -3181.865)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M2614.611,3460.757l-47.667-83.731c10.087-7.034,13.931-20.77,8.435-30.978,94.013-62.379,196.6-107.483,303.894-133.615,2.474,11.537,13.923,18.549,25.65,15.992q9.211,48.3,18.422,96.591c-10.792,2.355-17.478,13.854-15,25.383-94.224,22.948-184.309,62.556-266.866,117.335C2635.983,3457.531,2623.894,3454.285,2614.611,3460.757Z",
    transform: "translate(-2545.36 -3197.538)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(69.017 69.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M2942.257,3367.607c8.4,28.546-5.865,59.062-31.23,69.992-25.39,10.863-54.8-.9-66.369-28.087-11.555-27.134,1.61-60.7,30.168-72.941C2903.372,3324.294,2933.879,3339.11,2942.257,3367.607Z",
    transform: "translate(-2754.628 -3328.19)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M2741.511,3496.09q-35.855,18.726-70.269,40.747l-6.953-13.25q34.865-22.316,71.253-41.318Z",
    transform: "translate(-2664.289 -3405.123)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M3150.461,3338.827q-38.89,9.519-76.837,22.55l-4.227-14.571q38.447-13.2,77.914-22.865Z",
    transform: "translate(-2872.004 -3323.942)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(103.839 17.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M2919.609,3359.235l-1.654,8.852-9.619,4.175a16.5,16.5,0,0,1,4.1,2.729,19.953,19.953,0,0,1,3.515,4.3l10.406-4.517-1.654,8.853-5.781,2.509a19.925,19.925,0,0,1,.5,7.173,18.086,18.086,0,0,1-2.2,6.779,22.207,22.207,0,0,1-4.964,5.975,29.916,29.916,0,0,1-7.753,4.739l41.1,17.719-12.3,5.338-39.813-17.4-2.97-6.845,6.8-2.951a29.961,29.961,0,0,0,5.658-3.17,18.977,18.977,0,0,0,4.074-3.911,13.423,13.423,0,0,0,2.263-4.472,10.924,10.924,0,0,0,.209-4.9l-25.39,11.02,1.654-8.853,20.719-8.992a11.779,11.779,0,0,0-7.305-4.358q-4.516-.844-10.527,1.766l-11.285,4.9,1.654-8.852Z",
    transform: "translate(-2877.396 -3359.235)",
    fill: "#c9edf9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(2524.513 3275.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M2952.551,3532.7a849.452,849.452,0,0,0-342.863,50.25L2564.1,3433.269a982.185,982.185,0,0,1,396.427-58.1Q2956.538,3453.935,2952.551,3532.7Z",
    transform: "translate(-2564.099 -3373.381)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M2626.141,3560.829q-13.875-46.838-27.75-93.677c11.637-4.132,18.648-16.407,15.577-27.744a974.778,974.778,0,0,1,332.381-48.714c-.235,11.821,9.481,21.645,21.7,22.279q-2.119,49.182-4.238,98.366c-11.247-.584-20.552,8.773-20.787,20.586a856.008,856.008,0,0,0-291.881,42.778C2648.079,3563.375,2636.85,3557.028,2626.141,3560.829Z",
    transform: "translate(-2581.682 -3382.062)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(61.818 30.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M2997.584,3484.262c1.679,29.855-19.571,55.6-47.262,59.455-27.7,3.78-54.115-15.406-59.251-44.785-5.135-29.324,15.734-58.317,46.9-62.592C2969.125,3432.032,2995.916,3454.461,2997.584,3484.262Z",
    transform: "translate(-2793.17 -3435.809)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M2773.925,3561.8q-39.906,8.614-79.151,20.8l-3.806-14.668q39.76-12.349,80.26-21.09Q2772.577,3554.323,2773.925,3561.8Z",
    transform: "translate(-2690.968 -3492.741)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M3220.482,3519.57q-40.77-1.1-81.424,1.445-.4-7.611-.8-15.222,41.189-2.578,82.564-1.466Q3220.653,3511.948,3220.482,3519.57Z",
    transform: "translate(-2920.313 -3470.769)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(121.161 16.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M2985.941,3469.17l-3.233,8.4-10.218,2.359a16.524,16.524,0,0,1,3.533,3.428,19.972,19.972,0,0,1,2.676,4.867l11.053-2.552-3.234,8.4-6.14,1.418a19.905,19.905,0,0,1-.808,7.145,18.094,18.094,0,0,1-3.39,6.268,22.226,22.226,0,0,1-5.967,4.973,29.927,29.927,0,0,1-8.485,3.253l37.205,24.886-13.066,3.017-35.992-24.339-1.679-7.27,7.22-1.667a29.993,29.993,0,0,0,6.141-2.09,19.008,19.008,0,0,0,4.716-3.107,13.428,13.428,0,0,0,3.038-3.987,10.934,10.934,0,0,0,1.1-4.781l-26.969,6.227,3.233-8.4,22.008-5.082a11.782,11.782,0,0,0-6.393-5.612q-4.288-1.649-10.673-.175l-11.987,2.768,3.234-8.4Z",
    transform: "translate(-2939.626 -3469.17)",
    fill: "#c9edf9"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 480.072,
    height: 211.283,
    transform: "translate(2492.179 3338.795)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M3331.738,3826.843H3212.946a9.769,9.769,0,0,0-9.537,9.986h0a9.77,9.77,0,0,0,9.537,9.987h-15.4A9.769,9.769,0,0,0,3188,3856.8h0a9.769,9.769,0,0,0,9.537,9.986h2.669a9.77,9.77,0,0,0-9.537,9.987,10.345,10.345,0,0,0,.8,4.009h140.261Z",
    transform: "translate(-359.487 -330.706)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 437.019,
    height: 16.407,
    transform: "translate(2509.87 3349.198)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(2486.895 3425.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 229.475,
    height: 131.218,
    rx: 19,
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 56.51,
    height: 32.854,
    transform: "translate(14.754 26.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 100.21,
    height: 6.133,
    transform: "translate(114.737 17.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 184.423,
    height: 7.577,
    transform: "translate(23.077 87.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 184.423,
    height: 7.577,
    transform: "translate(23.077 105.702)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 203.767,
    height: 5.446,
    transform: "translate(2515.421 3392.739)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(2790.437 3266.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3192.382,3375.478a45.38,45.38,0,1,1-63.215-11.076A45.381,45.381,0,0,1,3192.382,3375.478Z",
    transform: "translate(-3109.852 -3356.163)",
    fill: "#ffcb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M3194.09,3387.354a38.08,38.08,0,1,1-53.046-9.294A38.081,38.081,0,0,1,3194.09,3387.354Z",
    transform: "translate(-3117.535 -3363.845)",
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(25.894 19.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M3195.313,3395.93l-2.476,5.662-7.078,1.3a11.314,11.314,0,0,1,2.317,2.459,13.7,13.7,0,0,1,1.685,3.419l7.656-1.409-2.476,5.662-4.253.783a13.686,13.686,0,0,1-.774,4.874,12.423,12.423,0,0,1-2.518,4.193,15.238,15.238,0,0,1-4.244,3.226,20.554,20.554,0,0,1-5.917,1.969l24.74,18.208-9.052,1.666-23.925-17.8-.927-5.036,5-.921a20.582,20.582,0,0,0,4.274-1.244,13.031,13.031,0,0,0,3.329-1.985,9.214,9.214,0,0,0,2.205-2.64,7.5,7.5,0,0,0,.9-3.243l-18.682,3.438,2.476-5.663,15.245-2.806a8.089,8.089,0,0,0-4.21-4.044,12.544,12.544,0,0,0-7.312-.449l-8.3,1.528,2.476-5.663Z",
    transform: "translate(-3162.994 -3395.93)",
    fill: "#eefbff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(2833.25 3412.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M3280.247,3673.55a45.38,45.38,0,1,1-63.215-11.076A45.381,45.381,0,0,1,3280.247,3673.55Z",
    transform: "translate(-3197.718 -3654.235)",
    fill: "#ffcb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M3281.954,3685.426a38.081,38.081,0,1,1-53.046-9.294A38.082,38.082,0,0,1,3281.954,3685.426Z",
    transform: "translate(-3205.4 -3661.918)",
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(29.288 17.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M3278.318,3744.989l-1.661-6.137a30.854,30.854,0,0,1-8.107.713,3.869,3.869,0,0,1-3.668-3.814l0-.246a3.862,3.862,0,0,1,4.1-3.913,22.559,22.559,0,0,0,7.333-.688c3.683-1,5.818-3.1,5.119-5.683-.664-2.454-3.151-3.446-8.367-3.768-7.542-.457-13.13-2.41-14.824-8.677-1.538-5.684,1.262-11.225,7.807-14.45l-1.66-6.137,6.331-1.712,1.537,5.684a28.523,28.523,0,0,1,6.124-.744,3.862,3.862,0,0,1,3.863,3.82h0a3.864,3.864,0,0,1-3.947,3.918,20.571,20.571,0,0,0-5.892.73c-4.2,1.135-5.066,3.311-4.577,5.12.577,2.132,3.2,2.877,9.255,3.459,8.421.634,12.482,3.349,14.054,9.162,1.555,5.749-1.187,11.759-8.267,15.06l1.782,6.589Z",
    transform: "translate(-3257.826 -3690.478)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(2745.057 3355.222)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 45.38,
    cy: 45.38,
    r: 45.38,
    transform: "translate(0)",
    fill: "#ffcb83"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 38.08,
    cy: 38.08,
    r: 38.08,
    transform: "matrix(0.21, -0.978, 0.978, 0.21, 0.157, 74.622)",
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(31.196 17.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M3121.78,3585.953l-5.24,3.276-6.577-2.921a11.344,11.344,0,0,1,.524,3.338,13.709,13.709,0,0,1-.54,3.773l7.115,3.159-5.241,3.276-3.952-1.755a13.681,13.681,0,0,1-3.391,3.586,12.417,12.417,0,0,1-4.445,2.039,15.245,15.245,0,0,1-5.324.267,20.522,20.522,0,0,1-6-1.716l10.141,29-8.411-3.735-9.7-28.2,2.078-4.68,4.648,2.064a20.584,20.584,0,0,0,4.23,1.386,13.027,13.027,0,0,0,3.868.241,9.2,9.2,0,0,0,3.31-.934,7.5,7.5,0,0,0,2.573-2.17l-17.36-7.709,5.24-3.276,14.167,6.291a8.085,8.085,0,0,0-1.191-5.715,12.553,12.553,0,0,0-5.782-4.5l-7.716-3.426,5.241-3.276Z",
    transform: "translate(-3080.742 -3573.639)",
    fill: "#eefbff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 205.533,
    height: 110.152,
    transform: "translate(2741.356 3426.771)",
    fill: "#c9edf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M3203.409,3836.828h0a9.77,9.77,0,0,0,9.537,9.987h-15.4A9.769,9.769,0,0,0,3188,3856.8h0a9.769,9.769,0,0,0,9.537,9.986h2.669a9.15,9.15,0,0,0-3.833.842h110v-40.786h-93.43A9.769,9.769,0,0,0,3203.409,3836.828Z",
    transform: "translate(-359.487 -330.706)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M3346.991,3931.055H3224.315a8.913,8.913,0,0,1-8.912-8.913h0a8.912,8.912,0,0,1,8.912-8.913h122.676a8.912,8.912,0,0,1,8.912,8.913h0A8.913,8.913,0,0,1,3346.991,3931.055Z",
    transform: "translate(-373.535 -374.999)",
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M3341.872,3894.473H3219.2a8.912,8.912,0,0,1-8.913-8.913h0a8.912,8.912,0,0,1,8.913-8.912h122.675a8.912,8.912,0,0,1,8.913,8.912h0A8.913,8.913,0,0,1,3341.872,3894.473Z",
    transform: "translate(-370.911 -356.243)",
    fill: "#ffcb83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M3371.415,3857.891H3248.74a8.912,8.912,0,0,1-8.913-8.912h0a8.913,8.913,0,0,1,8.913-8.913h122.675a8.913,8.913,0,0,1,8.913,8.913h0A8.912,8.912,0,0,1,3371.415,3857.891Z",
    transform: "translate(-386.058 -337.486)",
    fill: "#e6a748"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditReedem);
export default __webpack_public_path__ + "static/media/Credit Reedem.f5aecee708176fc8de1484289f47bff4.svg";
export { ForwardRef as ReactComponent };